const svgCache = new Map<string, HTMLElement | SVGElement | Error | undefined>()

export default svgCache
